import axios from "axios";
import { APIURL } from "../../../../APIHandler/APIURL"
import { Headers } from "../../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../../utlis/utlis";
import { Admin_Create_Event_failure, Admin_Create_Event_request, Admin_Create_Event_success } from "../../../Reducer/Admin/CreateEvents/CreateEvents";

export const AdminCreateEventAPI = (payload) => async (dispatch, getState) => {
    // const eventItemId=localStorage.getItem("eventItemId")
    const auth_token = localStorage.getItem("auth_token")
    dispatch(Admin_Create_Event_request())
    try {
        const { data } = await axios.post(`${APIURL.admincreateevent}`, payload,{
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
                // "Content-type": "application/json",
              "event-slug":Headers?.["event-slug"],
                "Content-type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${auth_token}`
            },
        })
        localStorage.setItem("admineventid",JSON.stringify(data?.data?.id))
        dispatch(Admin_Create_Event_success(data))
    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Admin_Create_Event_failure(error?.response?.data))
    }
}


  